// Compute the root-mean-square across leads at each sample index.
//
// Input: { [leadName]: number[] | Float32Array | Float64Array } — one waveform
// per lead. Leads may have different lengths (e.g. during a resample
// transition); at each index we average only the leads that have a finite
// value there.
//
// Output: number[] of length equal to the longest input lead. Empty input
// returns []. An index where no lead contributes a finite value yields 0.
const isArrayLike = (a) => a != null && typeof a.length === 'number' && typeof a !== 'string'

export const computeRmsWaveform = (leadSamples) => {
    if (!leadSamples) return []
    const leads = Object.values(leadSamples).filter(arr => isArrayLike(arr) && arr.length > 0)
    if (leads.length === 0) return []

    const outLen = leads.reduce((m, arr) => Math.max(m, arr.length), 0)
    const out = new Array(outLen)

    for (let i = 0; i < outLen; i++) {
        let sumSq = 0
        let count = 0
        for (let k = 0; k < leads.length; k++) {
            const v = leads[k][i]
            if (Number.isFinite(v)) {
                sumSq += v * v
                count += 1
            }
        }
        out[i] = count > 0 ? Math.sqrt(sumSq / count) : 0
    }
    return out
}

export default computeRmsWaveform
